import type { CountryQuerySchema } from './country-query-schema';

export function sanitizeCountry(c: CountryQuerySchema): CountryQuerySchema {
  return { ...c, calling_code: c.calling_code ?? '', phone_format: c.phone_format ?? '' };
}
